import React, { FC, ReactNode } from "react";
import classNames from "classnames";

import Icon, { IconType } from "../Icon/Icon";
import styles from "./Button.module.scss";

interface Props {
  size?: "small" | "medium" | "large";
  icon?: IconType;
  disabled?: boolean;
  outlined?: boolean;
  rounded?: boolean;
  color?: "blue" | "black" | "white" | "red" | "green";
  children?: ReactNode;
  onClick: () => void;
  dataQA: string;
  className?: string;
}

const Button: FC<Props> = ({
  color = "blue",
  size = "medium",
  disabled = false,
  icon,
  outlined = false,
  rounded = false,
  onClick,
  children,
  dataQA,
  className,
}) => {
  return (
    <button
      disabled={disabled}
      data-qa={dataQA}
      onClick={onClick}
      className={classNames(
        styles.button,
        styles[size],
        styles[color],
        className,
        {
          [styles.outlined]: outlined,
          [styles.rounded]: rounded,
        },
      )}
    >
      {icon && <Icon dataQA="icon" type={icon} className={styles.icon} />}
      <span data-qa="text">{children}</span>
    </button>
  );
};

export default Button;
